/**
 * The composite doc id for one attendance mark: offeringId_YYYY-MM-DD_studentId.
 *
 * Split out of lib/attendance.ts (which pulls in firebase/firestore) so this
 * one piece of arithmetic - the exact id a write OR a delete targets - is
 * directly testable under node's type stripping with no Firebase import at
 * all. lib/attendance.ts re-exports this unchanged, so every existing
 * `import { attendanceDocId } from '../lib/attendance'` keeps working.
 */
export function attendanceDocId(
  offeringId: string,
  date: string,
  studentId: string
): string {
  return `${offeringId}_${date}_${studentId}`;
}
